var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from "vue-property-decorator";
import * as moment from "moment";
var CalendarEvent = /** @class */ (function (_super) {
    __extends(CalendarEvent, _super);
    function CalendarEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CalendarEvent.prototype, "_isCalendarEvent", {
        get: function () { return true; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarEvent.prototype, "event", {
        get: function () {
            return {
                $component: this,
                title: this.title,
                start: parseDate(this.start),
                end: parseDate(this.end)
            };
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Prop({ type: String, required: true })
    ], CalendarEvent.prototype, "title", void 0);
    __decorate([
        Prop({ type: Object, required: true })
    ], CalendarEvent.prototype, "start", void 0);
    __decorate([
        Prop({ type: Object, required: true })
    ], CalendarEvent.prototype, "end", void 0);
    CalendarEvent = __decorate([
        Component({
            name: "CalendarEvent"
        })
    ], CalendarEvent);
    return CalendarEvent;
}(Vue));
export default CalendarEvent;
;
function parseDate(date) {
    return date._isAMomentObject === true
        ? date
        : moment(date);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Components/CalendarEvent.vue
// module id = 279
// module chunks = 0 1